var map = {
	"./g01p01.jpg": 1460,
	"./g01p02.jpg": 7388,
	"./g01p03.jpg": 3172,
	"./g01p04.jpg": 9764,
	"./g01p05.jpg": 2983,
	"./g01p06.jpg": 948,
	"assets/newCollection/homeOffice/FaceTime/group1/g01p01.jpg": 1460,
	"assets/newCollection/homeOffice/FaceTime/group1/g01p02.jpg": 7388,
	"assets/newCollection/homeOffice/FaceTime/group1/g01p03.jpg": 3172,
	"assets/newCollection/homeOffice/FaceTime/group1/g01p04.jpg": 9764,
	"assets/newCollection/homeOffice/FaceTime/group1/g01p05.jpg": 2983,
	"assets/newCollection/homeOffice/FaceTime/group1/g01p06.jpg": 948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5118;